import styled from "@emotion/styled";
import { DrawerControlButton } from "../drawer-control-button/drawer-control-button.component";

export const HostContainer = styled(DrawerControlButton)`
  position: absolute;
  top: 60px;
  left: -20px;
`;
